'use client';

import { FC } from 'react';
import { ConfirmActivateUserDialogProps } from './ConfirmActivateUserDialog.types';
import { Alert, Flex, Button, ButtonGroup, Dialog } from '@/_components';

export const ConfirmActivateUserDialog: FC<ConfirmActivateUserDialogProps> = ({
  companiesOfWhichIsPrimaryOwner,
  isOpen,
  onClose,
  onToggleActivateAccount,
  isLoading,
}) => {
  return (
    <Dialog isOpen={isOpen} onClose={onClose} title="Activate User">
      <Dialog.Content>
        <Flex isColumn={true} gap={12}>
          <Alert type="info">
            <div>
              Do you want to only activate this user OR activate this user and
              all these currently inactive entities of which it is the{' '}
              <strong>primary</strong> user?
            </div>
            <br />
            <ul>
              {companiesOfWhichIsPrimaryOwner.map((company) => (
                <li key={company.id}>- {company.name}</li>
              ))}
            </ul>
          </Alert>
          <ButtonGroup align="right">
            <Button
              value="Cancel"
              intent="secondary"
              onClick={onClose}
              isDisabled={isLoading}
            />
            <Button
              value="Activate user and its entities"
              intent="primary"
              isDisabled={isLoading}
              onClick={() => onToggleActivateAccount(true)}
            />
            <Button
              value="Activate user"
              intent="primary"
              isDisabled={isLoading}
              onClick={() => onToggleActivateAccount(false)}
            />
          </ButtonGroup>
        </Flex>
      </Dialog.Content>
    </Dialog>
  );
};
